module.exports = __webpack_public_path__ + "static/media/icon_arrow_D.d29a6842.svg";